/*global o_util*/

window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Identify the used device type (mobile, tablet, desktop) based on the user-agent.
 * The user-agent can be easily manipulated! Use the information with caution.
 *
 * @return {String} Used device type.
 */
o_global.device.type = (function(findInUserAgent) {
    "use strict";

    // Generic Mobile
    if (((findInUserAgent("mobile") && !findInUserAgent("ipad")) || findInUserAgent("(mobile;") || findInUserAgent("phone")) ||
        (findInUserAgent("android") && (findInUserAgent("mobile") && !findInUserAgent("ipad"))) ||
        (findInUserAgent("ipod") || findInUserAgent("iphone")) ||
        (findInUserAgent("windows") && findInUserAgent("phone")) ||
        (findInUserAgent("silk") && findInUserAgent("mobile")) ||
        (findInUserAgent("symbianos")) ||
        (findInUserAgent("(mobile;"))) {
        return "mobile";
    }

    // Generic Tablet
    if ((findInUserAgent("tablet") || findInUserAgent("(tablet;") || findInUserAgent("touch")) ||
        (findInUserAgent("android") && !findInUserAgent("mobile")) ||
        (findInUserAgent("ipad")) ||
        (findInUserAgent("windows") && !findInUserAgent("phone") && findInUserAgent("touch")) ||
        (findInUserAgent("silk") && !findInUserAgent("mobile")) ||
        (findInUserAgent("(tablet;"))) {
        return "tablet";
    }

    // Blackberry
    if (findInUserAgent("blackberry") || findInUserAgent("bb10") || findInUserAgent("rim")) {
        if (findInUserAgent("playbook") || findInUserAgent("tablet")) {
            return "tablet";
        } else {
            return "mobile";
        }
    }

    return "desktop";
}(o_util.browser.findInUserAgent));
